import React, {
  useMemo,
} from 'react';
import {
  getSubmitButtonText,
} from '@populateui/utils';
import {
  DropdownMenuItem,
} from 'core/components/DropdownMenu';
import SplitActionButton from 'core/components/SplitActionButton';
import StatementIcon from 'core/icons/statement';

type Props = {
  isLoading?: boolean;
  onPrepareStatement: (sendEmail?: boolean) => void;
};

export default function PrepareStatementButton({ isLoading = false, onPrepareStatement }: Props) {
  const buttonText = useMemo(
    () => getSubmitButtonText(true, isLoading, [['Prepare', 'Preparing']]),
    [isLoading],
  );

  const menuItems: DropdownMenuItem[] = useMemo(() => ([
    {
      id: 'print',
      label: 'Prepare to Print',
      onSelect: () => { onPrepareStatement(false); },
    },
    {
      id: 'printAndSend',
      label: 'Print and Email',
      onSelect: () => { onPrepareStatement(true); },
    },
  ]), [onPrepareStatement]);

  return (
    <SplitActionButton
      label={`${buttonText} Statement`}
      onPrimaryClick={() => { onPrepareStatement(false); }}
      items={menuItems}
      disabled={isLoading}
      disableElevation
      startIcon={<StatementIcon className="!w-4 !h-4" />}
      paperClassName="!min-w-[10rem]"
      placement="bottom-end"
    />
  );
}
